<template>
  <div class="home">
    <img v-if="!$vuetify.theme.dark" alt="SCM logo" src="../assets/logoTagline.png" class="logo"/>
    <img v-else alt="SCM logo" src="../assets/logoTaglineNegativo.png" class="logo"/>
    <h1>{{getTranslated('_welcome')}}</h1>
  </div>
</template>

<script>
import translationsService from '../services/TranslationsService'

export default {
  name: 'home',
  data () {
    return {
      translations: [ { key: '_welcome', translation: 'Welcome!' } ]
    }
  },
  methods: {
    async getTranslations () {
      if (this.$root.$data.user.profile !== undefined) {
        await translationsService.get(this.$route.name, this.$root.$data.user.profile['customclaim-language']).then(res => {
          this.translations = res.data
        })
      }
    },
    getTranslated (key) {
      var translation = this.translations.filter(element => element.key === key)
      if (translation.length > 0) {
        return translation[0].translation
      } else {
        return 'Translation Error: ' + key
      }
    },
    async initialize () {
      await this.getTranslations()
    }
  },
  created () {
    this.initialize()
  }
}
</script>

<style>
.logo {
  width: 40vh;
  height: 16vh;
}
</style>
